<script>
	import Buttons from "./Buttons.svelte";
	import AllTopicsView from "./AllTopicsView.svelte";
	import { selectedTopicId, topicButtons, showAllTopicsFilterView, scrollToTopOfMap } from "../stores";
	import { platform } from "../../../components/MediaQuerySsr.svelte";
	import Topic from "../components/Topic.svelte";
</script>

<div class="filters-container">
	{#if !$showAllTopicsFilterView}
		<div class="buttons">
			<Buttons scrollOnMobile bind:value={$selectedTopicId} options={$topicButtons} let:option let:active>
				<Topic
					colored={active}
					outlined
					shortLabel
					topicId={option.id}
					showCloseButton={active}
					onClose={(e) => {
						e.stopPropagation();
						$selectedTopicId = undefined;
					}}
				/>
			</Buttons>
		</div>
		<div
			class="all-button"
			class:desktop={$platform === "desktop"}
			on:click={() => {
				$scrollToTopOfMap();
				$showAllTopicsFilterView = true;
			}}
		>
			<img src={`${PATH}assets/images/icons/plus.svg`} />
			<div>
				{#if $platform === "desktop"}
					alle Demo-Themen anzeigen
				{:else}
					alle Themen
				{/if}
			</div>
		</div>
	{:else if $platform === "mobile"}
		<div class="all-topics-container">
			<AllTopicsView />
		</div>
	{/if}
</div>

<style lang="scss">
	.filters-container {
		display: flex;
		gap: 8px;

		@media (max-width: $breakpoint-tablet-l) {
			align-items: center;
		}
		@media (min-width: #{$breakpoint-tablet-l + 1px}) {
			flex-direction: column;
		}
	}

	.buttons {
		overflow: hidden;
		opacity: 0.8;
	}

	.all-button {
		border-radius: 4px;
		border: 1px solid rgba(255, 255, 255, 0.5);
		background: rgba(246, 246, 246, 0.2);
		font-size: 12px;
		line-height: 110%;
		display: flex;
		gap: 3px;
		align-items: center;
		padding: 3px 5px 3px 2px;
		cursor: pointer;

		&:hover {
			box-shadow: 0px 0px 15px rgba(255, 255, 255, 0.12);
			background: rgba(238, 238, 238, 0.4);
		}

		&.desktop {
			border-radius: 100px;
			white-space: nowrap;
			height: 32px;
			box-sizing: border-box;
			padding: 5px 8px 5px 5px;
			font-size: 13px;
			width: fit-content;
		}

		&:not(.desktop) {
			max-width: 57px;
		}
		img {
			width: 13px;
			height: 13px;
		}
	}
</style>
